<!-- -----------------------------------------------------------------------
 <copyright file="navbar.html" company="LGT India">
     Author: Sivapriya 
     Copyright (c) LGT India. All rights reserved.
 </copyright>
----------------------------------------------------------------------- -->
<div *ngIf="isLoading" class="loader-container">
  <span class="wait-text">Please Wait!</span>
  <mat-spinner diameter="30"></mat-spinner>
</div>

<div class="container-top" *ngIf="!isLoading">
  <div class="nav-bar-top">
    <div>
      <img
        src="../../assets/icons/lgtLogo.png"
        alt="image"
        width="111px"
        height="57.12px"
      />
    </div>
    <div>
      <mat-tab-group
        mat-stretch-tabs="false"
        mat-align-tabs="center"
        class="color"
        [selectedIndex]="selectedTabIndex"
        (selectedIndexChange)="onSelectTab($event)"
      >
        <ng-container
          *ngIf="loginAccessData === 'Yes' && loginSaData === 'Yes'"
        >
          <mat-tab class="color" label="View Transactions">
            <ng-template mat-tab-label class="color">
              <span class="my-custom-class">View Transactions</span>
            </ng-template>
          </mat-tab>
          <mat-tab label="User Manager">
            <ng-template mat-tab-label>
              <span class="my-custom-class">User Manager</span>
            </ng-template>
          </mat-tab>
          <mat-tab label="Audit Log Report">
            <ng-template mat-tab-label>
              <span class="my-custom-class">Audit Log Report</span>
            </ng-template>
          </mat-tab>
        </ng-container>
        <ng-container *ngIf="loginAccessData === 'Yes' && loginSaData === 'No'">
          <mat-tab class="color" label="View Transactions">
            <ng-template mat-tab-label class="color">
              <span class="my-custom-class">View Transactions</span>
            </ng-template>
          </mat-tab>
        </ng-container>
      </mat-tab-group>
    </div>
    <div class="login-container">
      <div class="login-avatar-div">
        <div>
          <img [src]="checkDataImage()" alt="checkDataImage" class="profile-image" />
        </div>
        <div>
          <h1 class="h1" *ngIf="isAdmin; else userSection">
            {{ email }}
            <p style="font-size: 15px; font-weight: 500;" [textContent]="checkUser()"></p>
          </h1>
          <ng-template #userSection>
            <h1 class="h1">
              {{ email }}
              <p style="font-size: 15px; font-weight: 500;" [textContent]="checkUser()"></p>
            </h1>
          </ng-template>
        </div>
      </div>
      <div
        class="login-button"
        style="cursor: pointer"
        (click)="openLogoutDialog()"
      >
        Logout
      </div>
    </div>
  </div>
  <div *ngIf="selectedTabIndex === 0">
    <app-transactions class="dialog-popup"></app-transactions>
  </div>
  <div *ngIf="selectedTabIndex === 1">
    <app-user></app-user>
  </div>
  <div *ngIf="selectedTabIndex === 2">
    <app-audit></app-audit>
  </div>
</div>
<div class="footer">
  <div class="version">UI Version - {{version}} </div>
</div>
